import type { PropsWithChildren } from 'preact/compat';
import IconButton from '../button/IconButton';
import './DrawerTitle.less';

type DrawerTitleProps = PropsWithChildren<{
    onCloseClick: () => void;
}>;

const DrawerTitle = ({ children, onCloseClick }: DrawerTitleProps) => (
    <div className="bri-DrawerTitle">
        <div className={'bri-DisplayBoldFont'}>{children}</div>
        <IconButton variant="primary" iconId="close" onClick={onCloseClick} />
    </div>
);

export default DrawerTitle;
